<script setup>
import { isEmpty } from 'lodash';
import {
  inject, nextTick, onMounted, ref, watch,
} from 'vue';

const I18n = inject('I18n');

const props = defineProps({
  // Array de calificaciones cada una con su definición y cada definición con su tipo_nota
  calificaciones: { type: Array, required: true },
  medias: { type: Array, default: null },
});

// Puede que tengamos calificaciones pero que no haya que mostrarlo porque no son
// numéricas, o solo hay una etc
const mostrar = ref(false);

function construirChart(ctx, labels, datasets) {
  const chart = new Chart(ctx, {
    type: 'line',
    data: {
      labels,
      datasets,
    },
    options: {
      legend: {
        position: 'right',
        onClick(e) {
          e.stopPropagation();
        },
        labels: {
          fontSize: 11,
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: I18n.t('Evolucion_evaluacion'),
      },
      label: { display: true },
      scales: {
        xAxes: [{
          gridLines: {
            display: false,
            drawBorder: false,
          },
        }],
        yAxes: [{
          gridLines: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            beginAtZero: true,
            stepSize: 5,
            suggedtedMax: 10,
          },
        }],
      },
    },
  });
}

/* global Chart */
function cargarGrafico() {
  const lineChart = document.getElementById('line-chart');

  if (!lineChart) {
    return;
  }

  const ctx = lineChart.getContext('2d');

  const labels = [];
  const data = [];
  const dataMedias = [];
  const procesarMedias = !isEmpty(props.medias);
  const cacheMedias = {};

  if (procesarMedias) {
    props.medias.forEach((infoMedia) => {
      cacheMedias[infoMedia.definicion_id] = Number.parseFloat(infoMedia.valor).toFixed(2);
    });
  }

  props.calificaciones.forEach((cal) => {
    const tipoNota = cal.definicion.tipo_nota;
    if (tipoNota.tipo_nota !== 'numerica') {
      return;
    }
    if (cal.tipo_puntuacion !== 'numerica') {
      return;
    }
    labels.push(cal.definicion.nombre);
    if ((cal.recuperacion?.valor || 0) > cal.valor) {
      data.push(cal.recuperacion.valor);
    } else {
      data.push(cal.valor);
    }

    if (procesarMedias) {
      dataMedias.push(cacheMedias[cal.definicion.id]);
    }
  });

  const datasets = [
    {
      label: I18n.t('Alumno'),
      data,
      fill: false,
      borderColor: '#676a6c',
      backgroundColor: '#676a6c',
    },
  ];

  if (procesarMedias) {
    const gradientFill = ctx.createLinearGradient(0, 0, 0, 250);
    gradientFill.addColorStop(0, 'rgba(129, 209, 129, 1)');
    gradientFill.addColorStop(1, 'rgba(229, 250, 229, 0.2)');

    datasets.push({
      label: I18n.t('Media_grupo'),
      data: dataMedias,
      backgroundColor: gradientFill,
    });
  }

  if (labels.length > 1) {
    mostrar.value = true;
    // Para que se vea la animación, primero mostramos el div y luego cargamos el gráfico
    nextTick(() => {
      construirChart(ctx, labels, datasets);
    });
  } else {
    mostrar.value = false;
  }
}

watch(() => props.calificaciones, () => {
  cargarGrafico();
});

onMounted(() => {
  cargarGrafico();
});
</script>

<template>
  <div v-if="!isEmpty(calificaciones)" v-show="mostrar" class="grafico-calificaciones-alumno">
    <div class="items-publicos-chart-wrapper">
      <canvas id="line-chart" width="900" height="250"></canvas>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/components/cuadernos/constantes_cuaderno.scss';
.grafico-calificaciones-alumno {
  border: 1px solid $dark-gray;
  border-radius: $border-radius;
}
</style>
